















import { PropType, defineComponent, computed } from '@vue/composition-api';
import { Message, ReportData } from '../../../dataType';
import { useLocale } from '../../../hooks/useLocale';
import {
  IntentCodeType,
  ReportDataType
} from './type';

export default defineComponent({
  components: {
  },
  props: {
    message: {
      type: Object as PropType<Message<ReportData<any>>>,
      required: true
    }
  },
  setup(props) {
    const { t } = useLocale();

    const msg = props.message.content.report.reportData.error.message;
    const reportData = computed(() => {
      return props.message.content.report.reportData as ReportDataType;
    });
    const intentCode = props.message.content.report.base.intentCode as IntentCodeType;
    return {
      t,
      msg,
      reportData,
      intentCode
    };
  }
});
